import { Button, Flex, Form, Modal, Typography } from 'antd';
import TextArea from 'antd/es/input/TextArea';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

const { Text } = Typography;

interface Props {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  handleAddNote: (note: string) => void;
}

type FormStateType = {
  note: string;
};

const initFormState: FormStateType = {
  note: ''
};

export default function AddRejectNote({ open, setOpen, handleAddNote }: Props) {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const [formState, setFormState] = useState(initFormState);

  const handleSubmit = () => {
    form
      .validateFields()
      .then(() => {
        handleAddNote(formState.note);
        setOpen(false);
        form.resetFields();
        setFormState(initFormState);
      })
      .catch(() => {});
  };

  const handleCancel = () => {
    setOpen(false);
    form.resetFields();
    setFormState(initFormState);
  };

  return (
    <Modal
      title={
        <Flex gap={4}>
          <Text>Lý do từ chối</Text>
          <Text type='danger'>*</Text>
        </Flex>
      }
      centered
      maskClosable={false}
      open={open}
      onOk={handleSubmit}
      onCancel={handleCancel}
      footer={[
        <Button key='back' onClick={handleCancel}>
          {t('action.cancel')}
        </Button>,
        <Button key='submit' type='primary' onClick={handleSubmit}>
          {t('action.submit')}
        </Button>
      ]}
    >
      <Form form={form} labelCol={{ span: 7 }}>
        <Form.Item
          label={false}
          name='note'
          rules={[
            {
              required: true,
              message: ''
            }
          ]}
        >
          <TextArea
            onChange={(e) => setFormState({ note: e.target.value })}
            rows={4}
            placeholder='Nhập lý do từ chối'
          />
        </Form.Item>
      </Form>
    </Modal>
  );
}
